<template>
    <div class="login-container">
        <div class="layer bg" id="login"></div>
        <div class="layer flex-center">
            <div class="form-group">
                <el-card>
                    <h3 class="title">代理控制台</h3>
                    <el-tabs v-model="type" stretch >
                        <el-tab-pane label="代理登陆" name="1"></el-tab-pane>
                        <el-tab-pane label="运营登陆" name="2"></el-tab-pane>
                    </el-tabs>
                    <el-form v-show="showLogin" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
                             label-position="left" label-width="0px" size="mini"
                             class="card-box login-form">
                        <el-form-item prop="account_operator" v-if="type == 2">
                            <el-input name="account_operator" v-model.trim="loginForm.account_operator" autoComplete="on"
                                      placeholder="请输入运营账户">
                                <template slot="prepend"><i class="icon iconfont icon-mine_fill"></i></template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="user_name">
                            <el-input name="user_name" v-model.trim="loginForm.user_name" autoComplete="on"
                                      :placeholder="type==1?'请输入账户':'请输入此账户的代理账户'">
                                <template slot="prepend"><i class="icon iconfont icon-mine_fill"></i></template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input name="password" :type="pwdType" @keyup.enter.native="handleLogin"
                                      v-model.trim="loginForm.password" autoComplete="on" placeholder="请输入密码">
                                <template slot="prepend"><i class="icon iconfont icon-lock_fill"></i></template>
                                <template slot="suffix"><span
                                        :class="['show-pwd icon iconfont', close?'icon-browse':'icon-Close']"
                                        @click="showPwd"></span></template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="user_vcode">
                            <el-input name="user_vcode" v-model.trim="loginForm.vcode" autoComplete="on"
                                      placeholder="请输入安全码，没有则不填写">
                                <template slot="prepend"><i class="icon iconfont icon-mine_fill"></i></template>
                            </el-input>
                        </el-form-item>
                      <el-row type="flex" class="table-btns" justify="end">
                        <el-link style="margin-bottom: 10px" @click="qrCode()" type="primary" target="_blank">绑定验证器</el-link>
                      </el-row>
                        <el-dialog title="请使用Google Authenticator扫码" :visible.sync="dialogVisible" width="25%">
                            <div id="qrcode"></div>
                            <span slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
                            </span>
                        </el-dialog>
                        <el-form-item>
                            <el-button type="primary" class="loginbtn" style="width:100%;" :loading="loading"
                                       @click.native="handleLogin">
                                登&nbsp;&nbsp;&nbsp;录
                            </el-button>
                        </el-form-item>
                    </el-form>
                  <div class="google_p" >
                    <span class="google_span">首次登录请先绑定验证器</span>
                    <span>请提前下载Google Authenticator应用程序用于扫描二维码和接收验证码</span>
                  </div>
                </el-card>

            </div>
        </div>

    </div>
</template>

<script>
    // require('particles.js')
    // import config from './config/default'
    import {isvalidUsername} from '@/utils/validate'
    import {setVcode} from "../../utils/auth";
    import {getVcodeSecret} from '@/api/login';
    import QRCode from 'qrcodejs2'

    export default {
        name: 'login',
        data() {
            const validateUsername = (rule, value, callback) => {
                if (!isvalidUsername(value)) {
                    callback(new Error('*请输入用户名'))
                } else {
                    callback()
                }
            }
            const validatePass = (rule, value, callback) => {
                if (value) {
                    if (value.length < 5) {
                        callback(new Error('*密码不能小于5位'))
                    } else {
                        callback()
                    }
                }
            }
            const validaterePass = (rule, value, callback) => {
                if (value === this.RegForm.password) {
                    callback()
                } else {
                    callback(new Error('*两次密码不一致'))
                }
            }
            const validateNickname = (rule, value, callback) => {
                if (value) {
                    if (value.length <= 0) {
                        callback(new Error('*请输入正确的昵称'))
                    } else {
                        callback()
                    }
                }
            }
            return {
                loginForm: {
                    user_name: '',
                    password: '',
                    account_operator:'',
                },
                close: false,
                RegForm: {},
                loginRules: {
                    user_name: [{required: true, trigger: 'blur', validator: validateUsername}],
                    password: [{required: true, trigger: 'blur', validator: validatePass}],
                    account_operator: [{required: true, trigger: 'blur', message: '请输入运营账户'}]
                },
                dialogVisible: false,
                loading: false,
                pwdType: 'password',
                showLogin: true,
                showReg: false,
                type: '1',
                vcode_secret: '',
            }
        },
        watch: {
            type(){
                this.loginForm = {
                    user_name: '',
                    password: '',
                    account_operator:'',
                }
            }
        },
        methods: {
            showPwd() {
                if (this.pwdType === 'password') {
                    this.pwdType = ''
                } else {
                    this.pwdType = 'password'
                }
                this.close = !this.close
            },
            toReg() {
                this.showLogin = false
                this.showReg = true
                this.RegForm = {}
            },
            toLogin() {
                this.showLogin = true
                this.showReg = false
                this.loginForm = {}
            },
            qrCode() {
                console.log(this.loginForm.user_name)
                console.log(this.loginForm.password)
                console.log(this.type)
                if (this.type == 1 && (!this.loginForm.user_name || !this.loginForm.password)) {
                    alert('请先输入账号密码！')
                    return
                }
                if (this.type == 2 && (!this.loginForm.user_name || !this.loginForm.password || !this.loginForm.account_operator)) {
                    alert('请先输入账号密码！')
                    return
                }
                getVcodeSecret(this.loginForm).then(res => {
                    if (res.status === 0) {
                        console.log(res.data)
                        this.vcode_secret = res.data.vcode_secret_url
                        this.dialogVisible = true;
                        this.$nextTick(function () {
                            document.getElementById("qrcode").innerHTML = "";
                            new QRCode("qrcode", {
                                width: 300,
                                height: 300,
                                text: this.vcode_secret,
                                colorDark: 'black',
                                colorLight: "white"
                            });
                        });
                    } else {
                        alert(res.msg)
                        return
                    }
                })
            },
            handleLogin() {
                // this.$router.push({ path: '/' })
                this.loginForm.data_type = window.location.port == '1103' ? 1 : 2
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        if(!(this.loginForm.vcode == '' || this.loginForm.vcode == undefined)){
                            setVcode(this.loginForm.vcode)
                        }
                        this.loading = true
                        const {user_name,password,account_operator} = this.loginForm;
                        let params;
                        if(this.type == 1){
                            params = {user_name,password}
                        }else{
                             params = {user_name,password,account_operator}
                        }

                        this.$store.dispatch('Login', params).then(() => {
                            this.loading = false
                            this.$router.push({path: '/'})
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    $bg: #2d3a4b;
    $dark_gray: #889aa4;
    $light_gray: #eee;

    .login-container {
        position: fixed;
        height: 100%;
        width: 100%;
        background: $bg;

        .el-input-group__prepend {
            padding: 0 0;
        }

        .layer {
            position: absolute;
            height: 100%;
            width: 100%;
        }

        .form-group {
            margin: 190px auto 0 auto;
            width: 400px;
          .google_p{
            font-size: 12px;
            color: #666;
            margin: 10px 0px;
            .google_span{
              margin-right: 10px;
              color: red;
            }
          }
        }

        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;
        }

        .svg-container {
            padding: 6px 5px 6px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 30px;
            display: inline-block;

            &_login {
                font-size: 20px;
            }
        }

        .title {
            font-size: 24px;
            font-weight: 400;
            text-align: center;
            font-weight: bold;
        }

        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            color: #454545;
        }

        .iconfont {
            font-size: 23px;
        }

        .show-pwd {
            position: absolute;
            right: 10px;
            top: 7px;
            font-size: 16px;
            color: $dark_gray;
            cursor: pointer;
            user-select: none;
        }

        .thirdparty-button {
            position: absolute;
            right: 35px;
            bottom: 28px;
        }
    }
</style>
